import areasJson from "../data/selections/areaDefinition.json";
import fieldsJson from "../data/selections/fieldDefinition.json";
import pathsJson from "../data/selections/pathDefinition.json";
import ChartAnnotationText from "./ChartAnnotationText";

const roninConditionText = (selectedState) => {
  const pathId = selectedState.pathId
  const partId = selectedState.partId
  const sectionId = selectedState.sectionId
  // 進路選択＝進学者のとき
  if (pathId === "C0") {
    // 進学先主催イベント設問のとき
    if (
      (partId === "P04") ||
      (partId === "P05" && sectionId === "S07")
    ) {
      return "※進学者は浪人を除く"
    }
  }
  return ""
}

const baseConditionText = (selectedState) => {
  const areaText = areasJson.options.find(area => area.id === selectedState.areaId).name + "エリア";
  const pathText = pathsJson["D0"].options.find(path => path.id === selectedState.pathId).name
  const fieldText = fieldsJson[selectedState.pathId].options.find(field => field.id === selectedState.fieldId).name
  return `※ベース絞り条件：「${areaText}」「${pathText}」「${fieldText}」`
}

const top15Text = (selectedState) => {
  const top15Data = [
    "P01/S03/E01",
    "P01/S05/E01",
    "P02/S01/E01",
    "P02/S02/E01",
    "P02/S03/E01",
    "P02/S04/E01",
    "P02/S07/E01",
    "P02/S07/E02",
    "P02/S07/E03",
    "P04/S03/E01",
    "P04/S08/E01",
    "P05/S04/E01",
    "P05/S05/E01",
    "P05/S06/E09",
    "P05/S07/E04",
    "P05/S07/E05",
    "P05/S07/E08",
    "P05/S08/E01",
    "P05/S08/E02",
    "P05/S09/E01",
    "P05/S09/E02",
    "P05/S11/E01",
  ]
  const {
    partId,
    sectionId,
    elementId
  } = selectedState
  if (top15Data.includes(`${partId}/${sectionId}/${elementId}`)) {
    return "※上位15位までの項目を表示"
  }
  return ""
}

const latestYearText = (selectedState) => {
  const { partId } = selectedState
  const LATEST_YEAR_IF_ENV_IS_NOT_SET = 2022;
  const latestYear = () => (process.env.REACT_APP_LATEST_YEAR || LATEST_YEAR_IF_ENV_IS_NOT_SET)
  if (partId !== "P05") {
    return `※最新年（${latestYear()}年）`
  } else {
    return ""
  }
}

function ChartAnnotation({ selectedState }) {
  return (
    <div className="pt-3">
      <ChartAnnotationText text={latestYearText(selectedState)} />
      <ChartAnnotationText text={baseConditionText(selectedState)} />
      <ChartAnnotationText text={top15Text(selectedState)} />
      <ChartAnnotationText text={roninConditionText(selectedState)} />
    </div>
  );
}

export default ChartAnnotation;
